// ForgotPasswordEmailForm.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ForgotPasswordEmailForm = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://summerhousagentlive.onrender.com/api/request-reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setMessage(t(data.message || 'Reset link sent successfully'));
    } catch (err) {
      setMessage(t('Error sending email'));
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>{t('Forgot Password')}</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="email"
          placeholder={t('Enter your registered email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={styles.input}
        />
        <button type="submit" style={styles.button}>{t('Send Reset Link')}</button>
      </form>
      {message && <p style={styles.message}>{message}</p>}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Link to="/loginform" style={styles.backLink}>← {t('Back to Login')}</Link>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '400px', margin: '50px auto', padding: '20px', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' },
  heading: { fontSize: '24px', marginBottom: '20px', textAlign: 'center', color: '#2980B9' },
  form: { display: 'flex', flexDirection: 'column', gap: '15px' },
  input: { padding: '10px', fontSize: '16px', borderRadius: '6px', border: '1px solid #ddd' },
  button: { padding: '10px', backgroundColor: '#2980B9', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  message: { marginTop: '15px', textAlign: 'center', color: '#27ae60' },
  backLink: { color: '#2980B9', textDecoration: 'none', fontWeight: 'bold' }
};

export default ForgotPasswordEmailForm;
